import $ from 'jquery';
import { Modal } from '../Modal/Modal';
import { cart } from '../Cart/Cart';

const unavailableNotification = {
  title: 'Je kunt deze training niet meer online boeken',
  message: 'Bel ons voor de laatste mogelijkheden',
  btnPrimary: {
    value: 'sluiten',
    class: 'js-close-modal',
    href: '',
  },
  btnSecondary: {
    value: '<i class=\'fa fa-phone\'></i> Bel 071-7900 040',
    class: '',
    href: 'tel:0717900040',
  },
};

/**
 * The cart list on the examentraining checkout page
 */
export class ExtFormCartList {
  constructor() {
    const $unavailableBtn = $('.js-upsell-unavailable-btn');
    const $addTrainingBtn = $('.js-upsell-book-btn');
    const $addArticleBtn = $('.js-article-book-btn');
    const $removeArticleBtn = $('.js-checkout-remove-article');
    const $removeTrainingBtn = $('.js-checkout-remove-training');

    // bind events
    $unavailableBtn.on('click', (e) => this.unavailableNotification(e));
    $addTrainingBtn.on('click', (e) => this.addTraining(e));
    $removeTrainingBtn.on('click', (e) => this.removeTraining(e));

    // articles are the subitems which are linked to the training
    $addArticleBtn.on('click', (e) => this.addArticle(e));
    $removeArticleBtn.on('click', (e) => this.removeArticle(e));
  }

  /**
     * Adds a sub item to the php session
     * @param e
     * @return void
     */
  // eslint-disable-next-line max-len
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-member-accessibility
  addArticle(e) {
    const $this = $(e.currentTarget);
    const trainingId = $this.data('training');
    const articleId = $this.data('item');
    this.showOverlay('Het item wordt toegevoegd...');

    cart.addArticle(trainingId, articleId)
      .then(() => location.reload())
      // eslint-disable-next-line no-console
      .catch(error => console.log('addArticle', error));
  }

  /**
     * Remove a sub item from the php session
     * @param e
     * @return void
     */
  // eslint-disable-next-line max-len
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-member-accessibility
  removeArticle(e) {
    e.preventDefault();

    const $this = $(e.currentTarget);
    const trainingId = $this.data('training');
    const articleId = $this.data('item');
    this.showOverlay('Het item wordt verwijderd...');

    cart.removeArticle(trainingId, articleId)
      .then(() => location.reload())
      // eslint-disable-next-line no-console
      .catch(error => console.log('removeArticle', error));
  }

  /**
     * Adds a training in the backend
     * @param e
     * @return void
     */
  // eslint-disable-next-line max-len
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-member-accessibility
  addTraining(e) {
    const trainingId = $(e.currentTarget).data('id');
    this.showOverlay('De training wordt toegevoegd.');

    // update php session
    cart.addTrainingId(trainingId)
      .then(() => location.reload())
      // eslint-disable-next-line no-console
      .catch(error => console.log('addTrainingId', error));
  }

  /**
     * Removes a training in the backend
     * @param e
     * @return void
     */
  // eslint-disable-next-line max-len
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-member-accessibility
  removeTraining(e) {
    e.preventDefault();
    this.showOverlay('De training wordt verwijderd...');

    const $this = $(e.currentTarget);
    const $cartItem = $this.closest('.checkout-list__product');

    const $subItems = $('.checkout-list__sub-item[data-training="' + $this.data('training') + '"]');

    $subItems.add($cartItem).remove();

    const trainingId = $this.data('training');

    // update php session
    cart.removeTraining(trainingId)
      .then(() => location.reload())
      // eslint-disable-next-line no-console
      .catch(error => console.log('removeTraining', error));
  }

  /**
     * The training in the upsell has been set
     * as contact training
     */
  // eslint-disable-next-line max-len
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-member-accessibility
  unavailableNotification() {
    new Modal(unavailableNotification);
  }

  /**
     *  Display an overlay while processing ajax requests
     */
  // eslint-disable-next-line max-len
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-member-accessibility
  showOverlay(text = 'Bezig...') {
    // $('#overlay').fadeIn(300).html(text ? text : 'Bezig...');
    $('#overlay').fadeIn(300).html('<div class="overlay-container">' + text + '</div>');
  }
}

